'use memo';

import { getEnumValue } from 'helpers/enumHelper';
import { Tabs } from 'types/Tabs';
import ResumeFormDetails from '../Common/ResumeFormDetails';
import AgencyAgreementSigningPanel from './AgencyAgreementSigningPanel';
import { CampaignDetailModel, CampaignDetailModelStage } from '@urbanx/agx.campaigns.client';

interface AgencyAgreementInfoPanelProps {
  campaign: CampaignDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const AgencyAgreementInfoPanel = ({
  campaign,
  currentTab,
  mobile = false,
}: AgencyAgreementInfoPanelProps) => {
  const campaignStage = getEnumValue(
    CampaignDetailModelStage,
    campaign.stage ?? CampaignDetailModelStage.AgreementDraft
  );

  switch (campaignStage) {
    case CampaignDetailModelStage.AgreementDraft:
      return <ResumeFormDetails currentTab={currentTab} campaign={campaign} mobile={mobile} />;
    case CampaignDetailModelStage.AgreementVendorSigning:
    case CampaignDetailModelStage.AgreementAgentSigning:
    case CampaignDetailModelStage.AgreementSignedByAllParties:
      return (
        <AgencyAgreementSigningPanel currentTab={currentTab} campaign={campaign} mobile={mobile} />
      );
    default:
      return null;
  }
};

export default AgencyAgreementInfoPanel;
